const CHARS = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
export const GSTIN_PATTERN = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

export const normalizeGstin = (v) => String(v || '').toUpperCase().replace(/\s+/g, '');

/** GSTIN check digit — base-36, weights 1/2 alternating, digit-sum of each product. Mirrors the backend. */
export function gstinChecksumOk(g) {
  if (!g || g.length !== 15) return false;
  let sum = 0;
  for (let i = 0; i < 14; i++) {
    const v = CHARS.indexOf(g[i]);
    if (v < 0) return false;
    const p = v * (i % 2 === 0 ? 1 : 2);
    sum += Math.floor(p / 36) + (p % 36);
  }
  return CHARS[(36 - (sum % 36)) % 36] === g[14];
}

/** null when fine (or still typing), otherwise a short human message */
export function gstinProblem(raw) {
  const g = normalizeGstin(raw);
  if (g.length < 15) return null;
  if (!GSTIN_PATTERN.test(g)) return 'That is not the GSTIN format (e.g. 27AAACR5055K1Z7)';
  if (!gstinChecksumOk(g)) return 'Check digit does not match — one character is probably mistyped';
  return null;
}

export const panFromGstin = (g) => normalizeGstin(g).slice(2, 12);
